import React, { memo } from 'react';

const ProjectCellComponent = ({ data }) => {
  if (!data) return <span />;

  const projectName = data.projectName || '';
  const flName = data.projectExecFLName ? ` - ${data.projectExecFLName}` : '';
  const username = data.projectHarvcoLeadUserName ? ` (${data.projectHarvcoLeadUserName})` : '';

  return <span>{projectName + flName + username}</span>;
};

export const ProjectCell = memo(ProjectCellComponent);
